export const genericAccountsSearchSiteCoreKeys = {
  searchGenericAccountHeader:
    "GenericAccount.SearchGenericAccount.SearchGenericAccountHeader",
  createGenericAccountButton:
    "SearchGenericAccountHeader.CreateGenericAccountButton",
  searchGenericAccountSection:
    "GenericAccount.SearchGenericAccount.SearchGenericAccountSection",
  genericAccountName: "SearchGenericAccountSection.GenericAccountName",
  purpose: "SearchGenericAccountSection.Purpose",
  client: "SearchGenericAccountSection.Client",
  nextView: "SearchGenericAccountSection.NextView",
  country: "SearchGenericAccountSection.Country",
  nextProgramClass: "SearchGenericAccountSection.NextProgramClass",
  deliveryOffice: "SearchGenericAccountSection.DeliveryOffice",
  genericAccountStatus: "SearchGenericAccountSection.GenericAccountStatus",
  requestedBy: "SearchGenericAccountSection.RequestedBy",
  genericAccountStatusList:
    "SearchGenericAccountSection.GenericAccountStatusList",
  purposeList: "SearchGenericAccountSection.PurposeList",
  expirationDate: "SearchGenericAccountSection.ExpirationDate",
  searchGenericAccountResults:
    "GenericAccount.SearchGenericAccount.SearchGenericAccountResults",
  genericAccountNameResults: "SearchGenericAccountResults.GenericAccountName",
  clientResults: "SearchGenericAccountResults.Client",
  purposeResults: "SearchGenericAccountResults.Purpose",
  registrationCode: "SearchGenericAccountResults.RegistrationCode",
  assignedAccounts: "SearchGenericAccountResults.AssignedAccounts",
  registeredAccounts: "SearchGenericAccountResults.RegisteredAccounts",
  action: "SearchGenericAccountResults.Action",
  genericAccountStatusListResults:
    "SearchGenericAccountResults.GenericAccountStatusList",
  purposeListResults: "SearchGenericAccountResults.PurposeList",
  exceededMaxNumberOfFilters: "FilterPopUp.ExceededMaxNumberOfFilters",
  existingFilters: "FilterPopUp.ExistingFilters",
  filterBeingDeletedMessage: "FilterPopUp.FilterBeingDeletedMessage",
  filterName: "FilterPopUp.FilterName",
  filters: "FilterPopUp.Filters",
  filtersBeingDeletedMessage: "FilterPopUp.FiltersBeingDeletedMessage",
  saveFilterTitle: "FilterPopUp.SaveFilterTitle",
  filterSavedMessage: "FilterPopUp.FilterSavedMessage",
  deleteFilter: "FilterPopUp.DeleteFilter",
  deleteFilterActionMessage: "FilterPopUp.DeleteFilterActionMessage",
  filterDeletedMessage: "FilterPopUp.FilterDeletedMessage",
  overwrite: "FilterPopUp.Overwrite",
  overwriteFilter: "FilterPopUp.OverwriteFilter",
  overwriteFilterActionMessage: "FilterPopUp.OverwriteFilterActionMessage",
  overwriteSuccessful: "FilterPopUp.OverwriteSuccessful",
  savingFilter: "FilterPopUp.SavingFilter",
  saveAsNew: "FilterPopUp.SaveAsNew",
  filterNameAlreadyExistsValidation:
    "FilterPopUp.FilterNameAlreadyExistsValidation",
  areYouSureYouWantToDeleteTheGenericAccount:
    "SearchGenericAccountResults.AreYouSureYouWantToDeleteTheGenericAccount",
  genericAccountDeleted: "SearchGenericAccountResults.GenericAccountDeleted",
};
